const TIMESHEET = [
	{ day: "Seg 08", in: "07:04", out: "17:02", hours: "8h58" },
	{ day: "Ter 09", in: "07:09", out: "17:05", hours: "8h56" },
	{ day: "Qua 10", in: "07:01", out: "16:58", hours: "8h57" },
];

export function PontoPanel() {
	return (
		<figure
			data-slot="panel"
			data-variant="ponto"
			aria-label="Exemplo da tela de ponto"
		>
			<div data-slot="ponto-now">
				<span data-slot="pill">Expediente ativo</span>
				<div>
					<div data-slot="ponto-clock">07:12</div>
					<small data-slot="muted">Carlos Souza · Armador</small>
				</div>
				<span data-slot="ponto-action">Bater saída agora</span>
				<dl data-slot="kv">
					<div>
						<dt>Entrada</dt>
						<dd>07:12</dd>
					</div>
					<div>
						<dt>Intervalo previsto</dt>
						<dd>12:00–13:00</dd>
					</div>
					<div>
						<dt>Saída prevista</dt>
						<dd>17:00</dd>
					</div>
				</dl>
			</div>
			<div data-slot="sheet">
				<p data-slot="eyebrow">Folha de horas · setembro</p>
				<table>
					<thead>
						<tr>
							<th>Dia</th>
							<th>Entrada</th>
							<th>Saída</th>
							<th data-align="end">Horas</th>
						</tr>
					</thead>
					<tbody>
						{TIMESHEET.map((row) => (
							<tr key={row.day}>
								<td>{row.day}</td>
								<td>{row.in}</td>
								<td>{row.out}</td>
								<td data-align="end">{row.hours}</td>
							</tr>
						))}
						<tr>
							<td>Qui 11</td>
							<td>07:12</td>
							<td data-muted="">—</td>
							<td data-align="end" data-muted="">
								em curso
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</figure>
	);
}
